import useIntl from '@/utils/intl'
import { ArrowForward, ArrowForwardIos } from '@mui/icons-material'
import React, { FunctionComponent } from 'react'
// import mobot from '../../../public/icons/mobot.svg'
import { ProductMin } from '@/services/m-commerce-api/product/product'
import { useLanguage } from '@/context/LanguageContext'
import cn from 'classnames'
import { useRouter } from 'next/navigation'
import DarkIconButton from '@/components/ui/Buttons/SecondaryIconButton'
import Image from 'next/image'
import { useContentContext } from '@/context/ContentContext'
import { IMG_URL } from '@/utils/constants'
import { useTheme } from '@/context/ThemeContext'

interface Prop {
  shopItems: Record<string, ProductMin[]>
}
const Handsets: FunctionComponent<Prop> = ({ shopItems }) => {
  const router = useRouter()
  const { translate } = useIntl()
  const { locale } = useLanguage()
  const [clicked, setClicked] = React.useState(0)
  const { state: { subcategories } } = useContentContext()
  const { theme } = useTheme()

  const renderCategory = (id: number): string => {
    const cat = subcategories?.find(e => e.id === id)
    if (cat !== undefined) {
      return cat.name
    }
    return ''
  }

  if (shopItems === undefined || shopItems === null) {
    return <></>
  }

  const selectedCategoryProduct = Object.entries(shopItems)[clicked][1]
  const bigCard = (): any => {
    if (selectedCategoryProduct[0] !== undefined) {
      return (
        <div
          id={'product.' + selectedCategoryProduct[0].id.toString()}
          className='rounded-xl border border-bordersm bg-surfaceInverse p-3 flex flex-col justify-between md:aspect-square 2xl:w-[641px] xl:w-[542px] lg:w-[384px] md:w-[560px] hover:border-[#EF4444] cursor-pointer'
          onClick={() => router.push('/product/' + selectedCategoryProduct[0]?.id.toString())}
        >
          <div className='flex justify-center'>
            <Image
              draggable={false}
              width={1000}
              height={1000}
              className='rounded-xl 2xl:w-[617px] 2xl:h-[523px] xl:w-[510px] xl:h-[428px] lg:w-[360px] lg:h-[266px] md:w-[536px] md:h-[396px] w-[300px] object-contain overflow-hidden'
              src={IMG_URL + selectedCategoryProduct[0]?.coverImage}
              alt='handset'
            />
          </div>
          <div className='flex items-center justify-between m-4'>
            <div>
              {/* to-do subcategory name get */}
              <span className='lg:text-sm text-xs font-bold text-textMid'>{renderCategory(selectedCategoryProduct[0]?.subCategoryId)}</span>
              <h1 className='font-bold xl:text-2xl md:text-xl text-lg text-textHigh'>{selectedCategoryProduct[0]?.nameMn}</h1>
            </div>
            <ArrowForwardIos className='text-sm text-textMid' />
          </div>
        </div>
      )
    } else {
      return <></>
    }
  }

  return (
    <div id='handsets' className='px-12 2xl:mt-24 xl:mt-12 flex flex-col items-center'>
      <div className='bg-surfaceWebGrey rounded-xl h-full flex flex-col items-center px-8 lg:py-20 py-16 shadow-[inset_0_0_12px_0_rgba(0,0,0,0.12)] w-[95vw] overflow-auto'>
        <p className='font-extrabold xl:text-5xl md:text-4xl text-3xl text-center text-textHigh'>{translate('homeNav.shop')}</p>
        <div className='flex mt-8 lg:mt-16 items-center'>
          <ul className='bg-[#0000001A] border border-[#FFFFFF1A] items-center justify-center p-2 gap-2 rounded-2xl h-fit flex'>
            {Object.keys(shopItems).map((item: string, i: number) => {
              const titles = item.split('/')
              const mn = titles[0]
              const en = titles[1]
              return (
                <li
                  id={'shop.' + en.toLowerCase()}
                  key={i}
                  className={cn('px-2 lg:px-5 py-2 rounded-xl font-semibold cursor-pointer hover:bg-secondarySoftMain h-10 flex items-center text-sm text-center', (i === clicked ? 'bg-secondary text-textInverse' : 'text-medium text-textHigh'))}
                  onClick={() => setClicked(i)}
                >{locale === 'en' ? en : mn}
                </li>
              )
            })}
          </ul>
          <div id='shop.seeAll' className='items-center ml-4 text-base hidden lg:flex hover:underline cursor-pointer' onClick={() => router.push('shop')}>
            <p className='ml-4 font-semibold text-sm text-textHigh'>{translate('shop.seeAll')}</p>
            <ArrowForward className='lg:text-base text-sm text-textHigh' />
          </div>
        </div>
        <div />
        <div className='flex mt-8 items-center justify-evenly w-full'>
          {/* <div className='hidden md:flex border border-[#777777] rounded-xl w-10 aspect-square justify-center items-center cursor-pointer hover:bg-black hover:text-textInverse' onClick={clicked === 1 ? () => setClicked(0) : () => setClicked(1)}>
            <ArrowBack />
          </div> */}
          <div className='hidden md:flex'>
            <DarkIconButton type='outlined' size='sm' iconImg={theme === 'dark' ? IMG_URL + '/uploads/icons/chevron-left-white.svg' : IMG_URL + '/uploads/icons/chevron-left.svg'} onClick={clicked === 1 ? () => setClicked(0) : () => setClicked(1)} />
          </div>
          <div className='flex flex-col lg:flex-row'>
            {bigCard()}
            <div className='lg:grid grid-cols-2 gap-4 ml-4 hidden'>
              {selectedCategoryProduct.map((item: ProductMin, i: number) => {
                if (i === 0) {
                  return null
                }
                return (
                  <div id={'product.' + item.id.toString()} key={i} className='rounded-xl border border-secondaryMidStroke p-3 flex flex-col justify-between bg-surfaceInverse aspect-square 2xl:w-[312px] xl:w-[263px] lg:w-[186px] hover:border-[#EF4444] cursor-pointer' onClick={() => router.push('/product/' + item.id.toString())}>
                    <div className='flex justify-center'>
                      <Image
                        draggable={false}
                        width={200}
                        height={200}
                        className='rounded-xl object-contain aspect-square 2xl:w-[187px] xl:w-[148px] lg:w-[104px]'
                        src={IMG_URL + item.coverImage}
                        alt='img'
                      />
                    </div>
                    <div className='flex items-center justify-between mt-3'>
                      <div>
                        <span className='lg:text-sm text-xs font-bold text-textMid'>{renderCategory(item.subCategoryId)}</span>
                        <h1 className='font-bold xl:text-lg lg:text-base text-sm truncate 2xl:w-[250px] xl:w-[215px] lg:w-[104px] text-textHigh'>{item.nameMn}</h1>
                      </div>
                      <ArrowForwardIos className='text-xs text-[#D4D4D8]' />
                    </div>
                  </div>
                )
              })}
            </div>
            <div className='flex gap-3 overflow-x-scroll scrollbar-thin lg:hidden mt-4 md:w-[560px] w-[85vw]'>
              {selectedCategoryProduct.map((item: ProductMin, i: number) => {
                if (i === 0) {
                  return null
                }
                return (
                  <div key={i} className='rounded-xl border border-bordersm p-3 flex flex-col justify-between bg-surfaceInverse aspect-square max-w-[186px]' onClick={() => router.push('/product/' + item.id.toString())}>
                    <div className='flex justify-center'>
                      <Image
                        draggable={false}
                        width={200}
                        height={200}
                        className='rounded-xl object-contain aspect-square max-w-[104px]'
                        src={IMG_URL + item.coverImage}
                        alt='img'
                      />
                    </div>
                    <div className='flex items-center justify-between mt-3 w-40'>
                      <div>
                        {/* <span className='text-xs font-bold'>{subCategories?.find(e => e.id === item.subCategoryId)?.name}</span> */}
                        <h1 className='font-bold text-sm truncate text-textHigh w-[108px]'>{item.nameEn ?? 'fix'}</h1>
                      </div>
                      <ArrowForwardIos className='text-xs text-[#D4D4D8]' />
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
          {/* <div className='hidden md:flex border border-[#777777] rounded-xl w-10 aspect-square justify-center items-center cursor-pointer hover:bg-black hover:text-textInverse' onClick={clicked === 1 ? () => setClicked(0) : () => setClicked(clicked + 1)}>
            <ArrowForward />
          </div> */}
          <div className='hidden md:flex'>
            <DarkIconButton type='outlined' size='sm' iconImg={theme === 'dark' ? IMG_URL + '/uploads/icons/chevron-right-white.svg' : IMG_URL + '/uploads/icons/chevron-right.svg'} onClick={clicked === 1 ? () => setClicked(0) : () => setClicked(clicked + 1)} />
          </div>
        </div>
        <div className='items-center ml-4 text-sm lg:hidden flex mt-12 hover:underline cursor-pointer' onClick={() => router.push('shop')}>
          <p className='ml-4 font-semibold text-sm text-textHigh'>{translate('shop.seeAll')}</p>
          <ArrowForward className='text-sm text-textHigh' />
        </div>
      </div>
    </div>
  )
}
export default Handsets
